var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-btn',{staticClass:"mr-4",attrs:{"color":"success"},on:{"click":_vm.getOrder}},[_vm._v(" View Order ")]),_c('v-btn',{staticClass:"mr-4",attrs:{"color":"success"},on:{"click":_vm.finish}},[_vm._v(" Finish ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }